import { apiHelper } from "../../utils/apiHelper/apiHelper";
import { toast } from "react-toastify";
import {
  DOWNLOAD_COUNT,
  MEDIATION_PAGE_LOADER,
  SET_MEDIATION_PAGE_DATA,
} from "../actionTypes";

export const getMediationPageData = () => async (dispatch) => {
  try {
    dispatch({
      type: MEDIATION_PAGE_LOADER,
      payload: true,
    });

    const res = await apiHelper("get", "/arb-and-med/mediations");
    if (res?.data) {
      dispatch({
        type: SET_MEDIATION_PAGE_DATA,
        payload: res?.data?.data?.mediation,
      });
    }
    dispatch({
      type: MEDIATION_PAGE_LOADER,
      payload: false,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    dispatch({
      type: MEDIATION_PAGE_LOADER,
      payload: false,
    });
  }
};

export const updateDownloadCount = (id, param) => async (dispatch) => {
  try {
    dispatch({
      type: MEDIATION_PAGE_LOADER,
      payload: true,
    });

    const res = await apiHelper(
      "get",
      `/arb-and-med/mediations/download/${id}?countUpdate=${param}`,
    );
    if (res?.data) {
      dispatch({
        type: DOWNLOAD_COUNT,
        payload: param,
      });
      dispatch({
        type: MEDIATION_PAGE_LOADER,
        payload: false,
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    dispatch({
      type: MEDIATION_PAGE_LOADER,
      payload: false,
    });
  }
};
